import { type InsuranceCorporateIdentity } from "../types";

export function RiekerRicostaWeisserLogo({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M145.16 159.12V153.65C145.16 151.68 145.95 149.75 147.4 148.36C148.82 146.93 150.71 146.14 152.68 146.14H154.07H170.23V135.89H152.92L151.56 136.02H149.5V136.15C140.31 137.18 133.17 144.97 133.17 154.45V155.59L133 155.58V178.54L145.25 178.52L145.16 159.12Z"
        fill="#D8001A"
      />
      <path d="M173.67 135.59H186.2V178.5H173.67V135.59Z" fill="#D8001A" />
      <path
        d="M239.82 178.65C239.82 178.65 214.96 178.58 210.11 178.58C205.31 178.58 189.93 172.23 189.93 157.44C189.93 142.68 203.97 135.39 214.2 135.39C224.47 135.39 239.82 141.71 239.82 152.92V162.88H210.66V153.32H225.74C225.74 153.32 226.04 146.37 214.48 146.37C202.95 146.37 203.04 154.89 203.04 157.08C203.04 157.08 203.1 167.53 211.76 167.53H239.82V178.65Z"
        fill="#D8001A"
      />
      <path
        d="M244.32 178.71V115.79H256.84V150.77H257.36L277.37 135.51H294.7L269.35 156.91L297.88 178.71H278.3L257.66 162.35H257.15V178.71H244.32Z"
        fill="#D8001A"
      />
      <path
        d="M338.86 178.71C338.86 178.71 313.93 178.68 309.12 178.68C304.33 178.68 288.98 172.33 288.98 157.54C288.98 142.73 302.91 135.47 313.18 135.47C323.45 135.47 338.87 141.8 338.87 153.01V162.98H309.64V153.38H324.72C324.72 153.38 325.06 146.45 313.54 146.45C301.94 146.45 302.03 154.93 302.03 157.2C302.03 157.2 302.12 167.57 310.79 167.57H338.87V178.71H338.86Z"
        fill="#D8001A"
      />
      <path
        d="M360.95 136.27L359.77 136.33L358.99 136.41C349.8 137.43 342.48 145.23 342.48 154.68L342.43 155.78V178.72H354.63L354.65 159.31V153.85C354.65 151.86 355.42 150 356.84 148.59C358.26 147.14 360.12 146.38 362.16 146.38H363.51L379.65 146.37V136.27H360.95Z"
        fill="#D8001A"
      />
      <path
        d="M192.46 118.42C193.73 119.51 195.93 122.42 200.7 122.29C199.23 121.04 196.4 117.75 195.91 115.89C193.34 111.82 196.43 111.55 200.42 111.46L200.51 104.9C199.01 105.09 195.87 105.59 196.3 103.59C197.61 102.34 199.02 101.68 201.02 102.08C203.59 102.67 203.98 106.42 203.12 109.35L203.09 110.43C202.99 113.17 202.96 113.65 203.79 116.18C204.35 117.38 205.59 118.64 207.2 118.26C210.42 117.88 213.91 115.33 214.7 112.11C213.63 112.31 212.86 111.81 212.32 111.06C213.27 105.59 217.54 101.32 218.43 95.7C218.39 93.23 217.54 91.18 215.33 89.56C211.54 87.03 206.72 87.05 202.37 88.88C195.25 90.77 189.83 97.74 188.73 104.74C188.05 104.74 187.21 105.31 186.71 104.74C187.75 99.16 191.73 94.65 193.15 89.25C196.11 78.27 188.76 68.88 180.11 63C174.04 68.12 168.99 73.14 166.55 80.33C164.19 90.22 171.45 96.59 173.55 104.94L173.07 104.98C172.4 104.98 171.94 105.16 171.01 104.98C170.26 99.59 167.3 93.88 162.17 91.24C157.12 87.73 150.65 86.78 144.36 90.55C137.27 98.23 147.68 104.22 147.79 112.09C147.23 112.55 146.76 113.41 145.8 113.14C146.92 116.16 149.34 118.51 153.63 118.92C160.56 116.44 154.36 105.49 158.76 102.5C160.56 101.56 162.84 102.6 163.89 104.22C162.72 105.29 161.25 104.65 159.67 104.89V111.89C161.85 111.52 163.27 112.28 164.2 112.73C166.18 115.13 164.33 117.69 163.42 118.86C162.48 119.99 161.58 121.22 159.68 122.24C163.65 122.8 166.28 120.51 168.95 118.17C170.96 115.97 170.92 111.14 174.44 113.39C173.28 117.3 171.3 121.07 169.01 124.03C172.53 126.93 176.29 129.43 180.4 132.23L191.44 124.03C188.04 120.38 185.97 113.13 186.08 113.06C188.55 111.3 190.52 116.87 192.46 118.42Z"
        fill="#D8001A"
      />
    </svg>
  );
}

export const RiekerRicostaWeisser: InsuranceCorporateIdentity = {
  id: "rieker-ricosta-weisser",
  name: "Rieker Ricosta Weisser",
  logo: RiekerRicostaWeisserLogo,
  backgroundColor: "white",
  textColor: "#000000",
  wildcard: "rieker ricosta weisser",
  type: "statutory",
};
